module.exports = __webpack_public_path__ + "img/Group 484.04ac4e64.png";